import type { FilesBlockData } from '#pages/document/editorjs-types';

export const NP_FILES_TAG = 'np-files';
export const NP_FILES_OPEN_TAG = `<${NP_FILES_TAG}>`;
export const NP_FILES_CLOSE_TAG = `</${NP_FILES_TAG}>`;

export interface ParsedMarkdownFilesConfig {
  data: FilesBlockData;
  rawConfig: string;
  parseError: string | null;
}

function normalizeRawConfig(value: string): string {
  return value.replace(/\r\n/g, '\n').trim();
}

function minifyJsonConfig(value: unknown): string {
  return JSON.stringify(value);
}

export function normalizeFilesBlockData(input: unknown): FilesBlockData {
  void input;
  return {};
}

export function stringifyMarkdownFilesConfig(data: FilesBlockData): string {
  void data;
  return JSON.stringify({}, null, 2);
}

export function parseMarkdownFilesConfig(
  rawConfig: string,
): ParsedMarkdownFilesConfig {
  const normalizedRaw = normalizeRawConfig(rawConfig);

  if (!normalizedRaw) {
    return {
      data: normalizeFilesBlockData({}),
      rawConfig: normalizedRaw,
      parseError: null,
    };
  }

  try {
    return {
      data: normalizeFilesBlockData(JSON.parse(normalizedRaw) as unknown),
      rawConfig: normalizedRaw,
      parseError: null,
    };
  } catch (error) {
    return {
      data: normalizeFilesBlockData({}),
      rawConfig: normalizedRaw,
      parseError:
        error instanceof Error ? error.message : 'Could not parse files JSON',
    };
  }
}

export function serializeMarkdownFilesBlock(params: {
  data: FilesBlockData;
  rawConfig?: string;
  parseError?: string | null;
}): string {
  return `${NP_FILES_OPEN_TAG}${serializeMarkdownFilesInnerConfig(params)}${NP_FILES_CLOSE_TAG}`;
}

export function serializeMarkdownFilesInnerConfig(params: {
  data: FilesBlockData;
  rawConfig?: string;
  parseError?: string | null;
}): string {
  const normalizedRaw = normalizeRawConfig(params.rawConfig ?? '');
  if (params.parseError && normalizedRaw) {
    return normalizedRaw;
  }

  if (normalizedRaw) {
    try {
      return minifyJsonConfig(JSON.parse(normalizedRaw) as unknown);
    } catch {
      return normalizedRaw;
    }
  }

  return minifyJsonConfig({});
}

export function createDefaultMarkdownFilesValue(): string {
  return serializeMarkdownFilesBlock({
    data: normalizeFilesBlockData({}),
    rawConfig: stringifyMarkdownFilesConfig({}),
    parseError: null,
  });
}
